import axiosInstance from './Instance/axiosInstance';
import { ReportData } from '../types/report';

export const fetchReport = async (startDate: string, endDate: string, customerCode = ''): Promise<ReportData> => {
    const res = await axiosInstance.get(`/orders/report?startDate=${startDate}&endDate=${endDate}&customerCode=${customerCode}`);
    return res.data;
};